export const projects = [
  {
    id: 1,
    title: "Foodie Social Platform ",
    description: "Foodie Social Platform is a vibrant social hub for cooking enthusiasts to explore, share, and grow their culinary skills. Whether you're a home cook or an aspiring chef, this platform brings together food lovers through recipe sharing, interactive cooking communities, and structured learning experiences.",
    tags: ["Web", "Fullstack", "React"],
    image: "/assets/images/projects/project2.png",
    github: "https://github.com/chathushkiupulini/PAF-Foodie-Social-Platform.git",
    //live: "https://yourecommerce.com"
  },
  {
    id: 2,
    title: "Luxo Travel",
    description: "Luxo Travel is a modern, responsive travel website built with React.js and SCSS. It offers users a seamless and visually engaging way to explore and plan trips to the world’s most beautiful destinations..",
    tags: ["Web", "Mobile", "React"],
    image: "/assets/images/projects/luxo.png",
    github: "https://github.com/chathushkiupulini/LuxoraTravels-.git",
    //live: "https://yourtaskapp.com"
  },
  {
    id: 3,
    title: "Portfolio Website",
    description: "A responsive portfolio website to showcase projects and skills.",
    tags: ["Web", "Design"],
    image: "/assets/images/projects/portfolio.png",
    github: "https://github.com/chathushkiupulini/my-portfolio.git",
    live: "https://my-portfolio-topaz-three-95.vercel.app/"
  }
];